import { Input } from 'components/Form'
import { GenericSelect } from 'components/Form/GenericSelect'
import { getStatesInCountry } from 'components/Form/stateCodes'
import { useMemo } from 'react'
import { noop } from 'utils'
import { AdvancedInputProps, BasicInputGroup } from '.'

export interface StateInputProps extends AdvancedInputProps {
  value?: string
  countryCode?: string
}

export const StateInput = ({
  name,
  value = '',
  label,
  countryCode,
  disabled,
  setFieldValue,
  onBlur = noop,
  error,
  tabIndex,
}: StateInputProps) => {
  const displayText = value || '-'
  const states = useMemo(() => {
    return getStatesInCountry(countryCode)
  }, [countryCode])
  const handleChange = (value: string) => {
    setFieldValue(name, value)
  }
  return (
    <BasicInputGroup
      name={name}
      label={label}
      error={error}
      display={displayText}
      disabled={disabled}
      input={
        states ? (
          <GenericSelect
            id={name}
            name={name}
            value={value}
            options={states}
            onBlur={onBlur}
            onChange={handleChange}
            tabIndex={tabIndex}
          />
        ) : (
          <Input
            id={name}
            name={name}
            onChange={(evt) => {
              const {
                target: { value },
              } = evt
              handleChange(value)
            }}
            onBlur={onBlur}
            value={value}
            aria-invalid={!!error}
            disabled={disabled}
            tabIndex={tabIndex}
          />
        )
      }
    />
  )
}
